import React from 'react';
import Icon from '../../../components/AppIcon';

const LoadingState = () => {
  return (
    <div className="space-y-4">
      {[...Array(6)]?.map((_, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-6 animate-pulse">
          <div className="flex items-start justify-between mb-4">
            <div className="flex items-start space-x-3 flex-1">
              <div className="w-12 h-12 bg-muted rounded-lg"></div>
              <div className="flex-1 space-y-2">
                <div className="h-5 bg-muted rounded w-3/4"></div>
                <div className="h-4 bg-muted rounded w-1/2"></div>
                <div className="h-3 bg-muted rounded w-2/3"></div>
              </div>
            </div>
            <div className="w-20 h-6 bg-muted rounded-full"></div>
          </div>
          
          <div className="space-y-2 mb-4">
            <div className="h-3 bg-muted rounded w-full"></div>
            <div className="h-3 bg-muted rounded w-4/5"></div>
          </div>
          
          <div className="flex space-x-2 mb-4">
            {[...Array(3)]?.map((_, i) => (
              <div key={i} className="h-6 w-16 bg-muted rounded"></div>
            ))}
          </div>
          
          <div className="flex items-center justify-between pt-4 border-t border-border">
            <div className="flex space-x-2">
              <div className="h-8 w-24 bg-muted rounded"></div>
              <div className="h-8 w-28 bg-muted rounded"></div>
            </div>
            <div className="h-6 w-16 bg-muted rounded-full"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

const EmptyState = ({ hasFilters, onClearFilters }) => {
  return (
    <div className="text-center py-12">
      <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
        <Icon name="Search" size={24} className="text-text-secondary" />
      </div>
      <h3 className="text-lg font-medium text-text-primary mb-2">
        {hasFilters ? 'No jobs match your filters' : 'No job matches found'}
      </h3>
      <p className="text-text-secondary mb-6 max-w-md mx-auto">
        {hasFilters 
          ? 'Try adjusting your search criteria or clearing some filters to see more opportunities.' :'We\'re working on finding the perfect matches for your profile. Check back soon for new opportunities.'
        }
      </p>
      {hasFilters && (
        <button
          onClick={onClearFilters}
          className="text-primary hover:text-primary/80 font-medium spring-transition"
        >
          Clear all filters
        </button>
      )}
    </div>
  );
};

export { LoadingState, EmptyState };